import { useTranslation } from 'react-i18next';
import VenafiIcon from '../../../assets/images/venafi-icon.svg';
import { IntegrationAccordion } from '../../../common/components/IntegrationAccordion';
import { Venafi } from '../../../integrations/venafi/models/Venafi';
import { VenafiAccordionForm } from './VenafiAccordionForm';
import { CheckVenafiIntegrationArgs, UpdateVenafiIntegrationArgs } from '../../../integrations/venafi/services/VenafiRepository';
import { useState } from 'react';

type Props = {
  venafi: Venafi | null;
  isLoading: boolean;
  onTestClick: (args: CheckVenafiIntegrationArgs) => void;
  onConnectClick: (args: UpdateVenafiIntegrationArgs) => void;
  onUnlinkClick: () => void;
  canUpdate: boolean;
};

export const VenafiAccordion = (props: Props) => {
  const { venafi, isLoading, onConnectClick, onTestClick, canUpdate, onUnlinkClick } = props;
  const { t } = useTranslation();
  const isVenafiEnabled = venafi !== null;
  const [isExpanded, setIsExpanded] = useState(true);
  const handleAccordionClick = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <IntegrationAccordion
      isExpanded={isExpanded}
      onClick={handleAccordionClick}
      isLoading={isLoading}
      isConfigured={isVenafiEnabled}
      title={t('integrationList.venafi.title')}
      subtitle={t('integrationList.venafi.description')}
      icon={<VenafiIcon width="31" height="25" />}
      details={
        !isLoading && (
          <VenafiAccordionForm canUpdate={canUpdate} venafi={venafi} onUnlinkClick={onUnlinkClick} onConnectClick={onConnectClick} onTestClick={onTestClick} />
        )
      }
    />
  );
};
